import React, { SetStateAction, useEffect, useState } from "react";
import { Modal } from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import styled from "styled-components";
import "../../../styles/CustomModal.css";
import { useToast } from "../../../controller/ToastController";

import {
  SetMenuGroupType,
  setMenuListType,
  setMenuType,
  setMenuOptionGrupType,
  pickGroupListType,
} from "../../../controller/StoreController";
import { useRecoilState } from "recoil";
import { LANG_JP, LANG_KO, langState, langText } from "../../../recoil/lang";
import {
  getPrdTypeName,
  getPrdName,
  getOptionTypeName,
  getOptionName,
} from "../../../utils/util";

type Props = {
  isVisible: boolean;
  setVisible: (bVisible: boolean) => void;
  setMenuGroup: SetMenuGroupType | undefined;
  setSelectedProduct: any;
  RenderProductDetail: any;
  selectedOption: number[][];
  setSelectedOption: React.Dispatch<SetStateAction<number[][]>>;
  addCart: (pick: pickGroupListType[]) => any;
  resetTimer: any;
};

const checkOption = (data: number[][]) => {
  return data.some((array) => array.length > 0) ? (
    <div className="optionLine"></div>
  ) : (
    ""
  );
};

// 세트메뉴 선택 메뉴, 옵션
const RenderSetMenuSelectList = (oProps: any) => {
  const setPick: pickGroupListType[] = oProps.pick;
  const pickArray = setPick.map(({ pick }) => pick);
  const inputMin: any = setPick.map(({ input_min }) => input_min);
  // const prdName: any = setPick.map(({ prd_type_name }) => prd_type_name);

  return (
    <div className="selectListWrap">
      {pickArray.map((product, index) => {
        return (
          <div key={index}>
            <div className="listWrap">
              {inputMin[index] > 0 ? (
                <h2 className="listTitle">
                  {langText.setOptionModal_configuration[oProps.lang]}
                  {index + 1} -
                  <span className="required">
                    ({langText.optionModal_title_Required[oProps.lang]})
                  </span>
                </h2>
              ) : (
                <>
                  <h2 className="listTitle">
                    {langText.setOptionModal_addtional[oProps.lang]} -
                    <span className="option">
                      ({langText.setOptionModal_option[oProps.lang]})
                    </span>
                  </h2>
                </>
              )}
              <div>
                {product?.length === 0 && (
                  <h2 className="listTitle">
                    {oProps.lang === LANG_KO || oProps.lang === LANG_JP
                      ? `[${getPrdTypeName(setPick[index], oProps.lang)}] `
                      : ""}
                    {langText.setOptionModal_select_menu[oProps.lang]}
                    {oProps.lang !== LANG_KO && oProps.lang !== LANG_JP
                      ? ` [${getPrdTypeName(setPick[index], oProps.lang)}]`
                      : ""}
                  </h2>
                )}
                {product?.length > 0 &&
                  product.map((renderProduct, index) => {
                    return (
                      <div key={index} className="selectMenuWrap">
                        <div className="selectMenu">
                          <h3>{getPrdName(renderProduct, oProps.lang)}</h3>
                          <h2>{checkOption(renderProduct.pick)}</h2>
                          {renderProduct.pick.map((oPtion, optGroupIdx) => {
                            return (
                              <div className="selectOptionWrap">
                                {oPtion.map((optionIdx) => {
                                  return (
                                    <>
                                      <h2 className="selectOptionName">
                                        {getOptionName(
                                          renderProduct.option_group_list[
                                            optGroupIdx
                                          ].option_list[optionIdx],
                                          oProps.lang
                                        )}
                                      </h2>
                                    </>
                                  );
                                })}
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    );
                  })}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};
const RenderSetMenu = (oProps: any) => {
  const showToast = useToast();
  const [selectedTab, setSelectedTab] = useState(0);
  //세트메뉴 전체 정보
  const setMenuGroup: SetMenuGroupType = oProps.setMenuGroup;
  //tab정보(메뉴그룹)
  const setMenuTabList: setMenuListType[] = setMenuGroup.set_prd_type_list;
  //선택된 tab정보(메뉴그룹)
  const selectedProductType: setMenuListType = setMenuTabList[selectedTab];
  //선택된 메뉴그룹의 메뉴
  const setMenu: setMenuType[] = selectedProductType?.product_list || [];
  //메뉴그룹안에서 선택된 메뉴
  const [selectedMenus, setSelectedMenus] = useState<number[]>(
    Array(setMenuTabList.length).fill(null)
  );
  //메뉴그룹안에서 선택된 메뉴의 선택개수정보
  const { input_max, input_min } = setMenuTabList[selectedTab];

  //옵션그룹의 전체옵션
  const setMenuTotalOption: any = setMenu.map((data) => data.option_group_list);

  // 메뉴그룹 tab선택
  const handleTabClick = (index: number) => {
    setSelectedTab(index);
  };
  //메뉴그룹의 메뉴 선택
  const handleSetMenuClick = (selectedTab: number, index: number) => {
    const pick: pickGroupListType[] = [...oProps.pick];
    const productGroup = setMenuGroup.set_prd_type_list[selectedTab];
    const product = productGroup.product_list[index];
    const findIndex = pick[selectedTab].pick.findIndex(
      (obj) => obj.prd_id === product.prd_id
    );

    //TODO 담기
    if (findIndex === -1) {
      if (
        pick[selectedTab].input_min === 1 &&
        pick[selectedTab].input_max === 1
      ) {
        // 라디오일때
        pick[selectedTab].pick = [
          {
            ...product,
            pick: Array.from(
              { length: product.option_group_list.length },
              () => []
            ),
          },
        ];
      } else if (pick[selectedTab].pick.length >= pick[selectedTab].input_max) {
        showToast(
          `${langText.optionModal_title_Maximum[oProps.lang]} ${
            pick[selectedTab].input_max
          } ${langText.title_detail_count[oProps.lang]}${
            langText.setOptionModal_maximum_count[oProps.lang]
          }`
        );
      } else {
        pick[selectedTab].pick.push({
          ...product,
          pick: Array.from(
            { length: product.option_group_list.length },
            () => []
          ),
        });
      }
    } else {
      if (
        pick[selectedTab].input_min === 1 &&
        pick[selectedTab].input_max === 1
      ) {
        // 라디오일때
      } else {
        pick[selectedTab].pick.splice(findIndex, 1);
      }
    }
    oProps.setPick(pick);

    //!!XXXX

    // // console.log("+===>>.",pick);

    // console.log(setMenuGroup.set_prd_type_list[selectedTab].product_list[index].prd_name);

    // // oProps.setPick();
    // // if(oProps.setPick)
    // console.log(selectedTab,index);

    // const updatedSelectedMenus = [...selectedMenus];
    // updatedSelectedMenus[selectedTab] = index;
    // setSelectedMenus(updatedSelectedMenus);
  };
  const handleOptionClick = (
    selectedTab: number,
    product_index: number,
    option_group_index: number,
    index: number
  ) => {
    const pick: pickGroupListType[] = [...oProps.pick];
    const pickOptionGroup =
      pick[selectedTab].product_list[product_index].option_group_list[
        option_group_index
      ];
    const productGroup = setMenuGroup.set_prd_type_list[selectedTab];
    const product = productGroup.product_list[product_index];
    const optionGroup = product.option_group_list[option_group_index];
    const option = optionGroup.option_list[index];

    const pickProductIndex = pick[selectedTab].pick.findIndex(
      (obj) => obj.prd_id === product.prd_id
    );

    const pickOptionIndex = pick[selectedTab].pick[pickProductIndex].pick[
      option_group_index
    ].findIndex((idx) => idx === index);

    const optionSold = option.is_soldout === 1;
    if (pickOptionIndex === -1) {
      if (optionSold) {
        return;
      }
      if (
        pickOptionGroup.option_input_min === 1 &&
        pickOptionGroup.option_input_max === 1
      ) {
        //라디오일경우
        pick[selectedTab].pick[pickProductIndex].pick[option_group_index] = [
          index,
        ];
      } else if (
        pick[selectedTab].pick[pickProductIndex].pick[option_group_index]
          .length >= pickOptionGroup.option_input_max
      ) {
        showToast(
          `${langText.optionModal_title_Maximum[oProps.lang]} ${
            pick[selectedTab].input_max
          } ${langText.setOptionModal_maximum_count[oProps.lang]}`
        );
      } else {
        pick[selectedTab].pick[pickProductIndex].pick[option_group_index].push(
          index
        );
      }
    } else {
      if (
        pickOptionGroup.option_input_min === 1 &&
        pickOptionGroup.option_input_max === 1
      ) {
        // 라디오일때
      } else {
        pick[selectedTab].pick[pickProductIndex].pick[
          option_group_index
        ].splice(pickOptionIndex, 1);
        // pick[selectedTab].pick.splice(findIndex, 1);
      }
    }

    oProps.setPick(pick);

    console.log(
      "옵션클릭:",
      setMenuGroup.set_prd_type_list[selectedTab].product_list[product_index]
        .option_group_list[option_group_index].option_list[index]
    );
  };

  return (
    <>
      {/* setMenuTab */}
      <div className="tabContainer wrapContainer">
        {setMenuTabList.map((productType, index) => (
          <div
            key={productType.prd_type_id}
            className={`tab ${selectedTab === index ? "active" : ""}`}
            onClick={() => handleTabClick(index)}
          >
            <div className="tabButton">
              {productType.input_min > 0 ? (
                <>
                  <h2>
                    {langText.setOptionModal_configuration[oProps.lang]}
                    {index + 1}
                  </h2>
                  <img
                    className="backButton"
                    src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_require.svg`}
                    alt="필수"
                  />
                </>
              ) : (
                <h2>{langText.setOptionModal_addtional[oProps.lang]}</h2>
              )}
            </div>
          </div>
        ))}
      </div>
      <div className="optionListWrap wrapContainer">
        {/* setMenu */}
        <div className="setMenuWrap">
          <div className="menuTitle">
            <h1>{getPrdTypeName(setMenuTabList[selectedTab], oProps.lang)}</h1>
            {input_min > 0 && input_min === input_max && (
              <h2>
                ({langText.optionModal_title_Required[oProps.lang]} {input_min}
                {langText.title_detail_count[oProps.lang]})
              </h2>
            )}
            {input_min > 0 && input_min !== input_max && (
              <h2>
                ({langText.optionModal_title_Required[oProps.lang]} {input_min}
                {langText.title_detail_count[oProps.lang]})
                <span>
                  ({langText.optionModal_title_Maximum[oProps.lang]} {input_max}
                  {langText.title_detail_count[oProps.lang]})
                </span>
              </h2>
            )}
            {input_min === 0 && (
              <span>
                ({langText.optionModal_title_Maximum[oProps.lang]} {input_max}
                {langText.title_detail_count[oProps.lang]})
              </span>
            )}
          </div>
          <div className="setMenuInfoWrap">
            {setMenu.map((menu, index) => {
              const { prd_id, prd_name, prd_price, is_soldout } = menu;
              const isSelected =
                oProps.pick[selectedTab].pick.findIndex(
                  (obj: any) => obj.prd_id === prd_id
                ) !== -1;

              const handleClick = () => {
                if (is_soldout === 0) {
                  handleSetMenuClick(selectedTab, index);
                }
              };
              return (
                <div
                  className={`setMenuInfo ${isSelected ? "selected" : ""} ${
                    is_soldout === 1 ? "sold" : ""
                  }`}
                  key={prd_id}
                  onClick={handleClick}
                >
                  <h3>{getPrdName(menu, oProps.lang)}</h3>
                  <h4>{prd_price}원</h4>
                  {is_soldout === 1 && (
                    <div className="soldText">
                      <h2>SOLD OUT</h2>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
          {/* setMenuOption */}
          <div className="menuOptionWrap">
            {setMenu.map((menu, product_index) => (
              <div key={menu.prd_id}>
                {menu.option_group_list.length > 0 && (
                  <div>
                    {oProps.pick[selectedTab].pick.findIndex(
                      (obj: any) => obj.prd_id === menu.prd_id
                    ) !== -1 && (
                      <div className="optionName">
                        <h3>
                          {getPrdName(menu, oProps.lang)}
                          {langText.setOptionModal_select_option[oProps.lang]}
                        </h3>
                      </div>
                    )}
                    {
                      <>
                        {menu.option_group_list.map(
                          (
                            optionGroup: setMenuOptionGrupType,
                            option_group_index: number
                          ) => {
                            const pick: pickGroupListType[] = oProps.pick;
                            const pickProductIndex = pick[
                              selectedTab
                            ].pick.findIndex(
                              (obj) => obj.prd_id === menu.prd_id
                            );
                            if (
                              oProps.pick[selectedTab].pick.findIndex(
                                (obj: any) => obj.prd_id === menu.prd_id
                              ) === -1
                            ) {
                              return <></>;
                            } else {
                              return (
                                <>
                                  <div key={optionGroup.option_type_id}>
                                    <div className="menuOptionTitle">
                                      <h2>
                                        {getOptionTypeName(
                                          optionGroup,
                                          oProps.lang
                                        )}
                                      </h2>
                                      <span>
                                        (
                                        {
                                          langText.optionModal_title_Required[
                                            oProps.lang
                                          ]
                                        }
                                        {optionGroup.option_input_min}
                                        {
                                          langText.title_detail_count[
                                            oProps.lang
                                          ]
                                        }
                                        )
                                        {optionGroup.option_input_max !=
                                        optionGroup.option_input_min
                                          ? `(${
                                              langText
                                                .optionModal_title_Maximum[
                                                oProps.lang
                                              ]
                                            } ${optionGroup.option_input_max}${
                                              langText.title_detail_count[
                                                oProps.lang
                                              ]
                                            })`
                                          : ""}
                                      </span>
                                    </div>
                                    <div className="optionGroupWrap">
                                      {optionGroup.option_list.map(
                                        (option, index: number) => (
                                          <div
                                            className={`optionGroup ${
                                              option.is_soldout === 1
                                                ? "sold"
                                                : pickProductIndex !== -1 &&
                                                  pick[selectedTab].pick[
                                                    pickProductIndex
                                                  ].pick[
                                                    option_group_index
                                                  ].includes(index)
                                                ? "active"
                                                : ""
                                            }`}
                                            onClick={() => {
                                              handleOptionClick(
                                                selectedTab,
                                                product_index,
                                                option_group_index,
                                                index
                                              );
                                              console.log(
                                                pickProductIndex,
                                                option_group_index
                                              );
                                            }}
                                            key={index}
                                          >
                                            <h2>
                                              {getOptionName(
                                                option,
                                                oProps.lang
                                              )}
                                            </h2>
                                            <p>{option.option_price}원</p>
                                          </div>
                                        )
                                      )}
                                    </div>
                                  </div>
                                </>
                              );
                            }
                          }
                        )}
                      </>
                    }
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};
const OptionModal = ({
  isVisible,
  setVisible,
  setMenuGroup,
  setSelectedProduct,
  RenderProductDetail,
  selectedOption,
  setSelectedOption,
  addCart,
  resetTimer,
}: Props) => {
  const [lang, setLang] = useRecoilState<number>(langState);
  const [selectedItems, setSelectedItems] = useState([]);
  const [pick, setPick] = useState<pickGroupListType[]>([]);

  // 옵션 닫기 버튼
  const onCloseModal = () => {
    setVisible(false);
  };

  useEffect(() => {
    if (!isVisible) {
      setSelectedOption([]);
      setSelectedProduct([]);
    }
  }, [isVisible]);

  useEffect(() => {
    console.log(pick);
  }, [pick]);

  useEffect(() => {
    if (setMenuGroup !== undefined) {
      const pickGroupList: pickGroupListType[] = [];
      for (let i = 0; i < setMenuGroup.set_prd_type_list.length; i++) {
        const productGroup = setMenuGroup.set_prd_type_list[i];
        if (
          productGroup.input_min === 1 &&
          productGroup.input_max === 1 &&
          productGroup.product_list.length > 0
        ) {
          let productInitPick: pickGroupListType = {
            ...productGroup,
            pick: [
              {
                ...productGroup.product_list[0],
                pick: Array.from(
                  {
                    length:
                      productGroup.product_list[0].option_group_list.length,
                  },
                  () => []
                ),
              },
            ],
          };
          pickGroupList.push(productInitPick);
        } else {
          pickGroupList.push({
            ...productGroup,
            pick: [],
          });
        }
      }

      setPick(pickGroupList);
    }
  }, [setMenuGroup]);

  if (!isVisible || !setMenuGroup) {
    return null;
  }

  return (
    <Modal
      open={isVisible}
      onClose={onCloseModal}
      center
      classNames={{
        overlay: "setOptionCustomOverlay",
        modal: "setOptionCustomModal",
      }}
      showCloseIcon={false}
      animationDuration={150}
    >
      <Style>
        <div
          className="setMenuOptionWrap"
          onTouchStart={resetTimer}
          onScrollCapture={resetTimer}
        >
          <div className="optionTitle">
            <h2>{langText.setOptionModal_title[lang]}</h2>
            <button onClick={onCloseModal}>
              <img
                src={`${process.env.PUBLIC_URL}/knockknock/svg/optionClose.svg`}
                alt="옵션닫기"
              />
            </button>
          </div>

          <RenderProductDetail />
          <RenderSetMenuSelectList
            pick={pick}
            lang={lang}
            setMenuGroup={setMenuGroup}
          />
          <RenderSetMenu
            setMenuGroup={setMenuGroup}
            selectedOption={selectedOption}
            setSelectedOption={setSelectedOption}
            setVisible={setVisible}
            lang={lang}
            selectedItems={selectedItems}
            setSelectedItems={setSelectedItems}
            pick={pick}
            setPick={setPick}
          />
          <div className="modalFooter">
            <button className="resetOptonButton" onClick={onCloseModal}>
              <h2>{langText.optionModal_button_ClearAll[lang]}</h2>
            </button>
            <button
              onClick={() => {
                addCart(pick);
              }}
            >
              <h2>{langText.optionModal_button_AddToCart[lang]}</h2>
            </button>
          </div>
        </div>
      </Style>
    </Modal>
  );
};

export default OptionModal;

const Style = styled.div`
  .setMenuOptionWrap {
    display: flex;
    flex-direction: column;
    height: 85vh;
  }
  .optionTitle {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 22px 21px 20px 45px;

    h2 {
      font-size: 24px;
      font-weight: 300;
      color: #fff;
    }
  }

  /* 옵션 상세 설명 */
  .productDetailWrap {
    width: 100%;
    padding: 0 45px 16px 45px;
    display: flex;
    align-items: stretch;
    justify-content: space-between;

    .detailImgWrap {
      max-width: 200px;
      img {
        aspect-ratio: 5/4;
      }
    }
    .detailTextWrap {
      flex: 1;
      margin-left: 20px;

      p {
        width: 100%;
        margin: 16px 0 0 0;
        font-size: 16px;
        font-weight: 400;
        color: #a7a7a7;
        line-height: 24px;
        word-break: keep-all;
        overflow-y: auto;
        max-height: 8.5vh;
      }
    }
    .detailImg {
      width: 100%;
      border-radius: 10px;
    }
  }
  .detailTextTitle {
    .detailName {
      flex: 1;
      margin-bottom: 6px;
    }
  }

  /* selectListWrap */
  .selectListWrap {
    display: flex;
    flex-direction: column;
    gap: 14px;
    background: #232323;
    min-height: 100px;
    max-height: 160px;
    overflow-y: auto;
    padding: 14px 50px;
  }
  .listWrap {
    display: flex;

    .listTitle {
      margin-right: 8px;
      padding: 4px 0;
      font-size: 16px;
      font-weight: 400;
      color: #e5e5e5;

      .required,
      .option {
        font-size: 12px;
        font-weight: 500;
        color: #ff4a4a;
      }
      .option {
        color: #4dd2ae;
      }
    }
  }
  .selectMenuWrap {
    /* background: pink; */
  }
  .selectMenuWrap:nth-child(2) {
    margin-top: 4px;
  }
  .selectMenu {
    padding: 4px 10px;
    display: inline-flex;
    align-items: center;

    h3 {
      font-size: 16px;
      font-weight: 400;
      color: #e5e5e5;
    }
  }
  .selectOptionWrap {
    display: flex;

    .selectOptionName {
      font-size: 16px;
      font-weight: 400;
      color: #e5e5e5;
      border: 1px solid #e5e5e5;
      padding: 2px 8px 1px 8px;
      border-radius: 15px;
      margin-right: 4px;
    }
  }
  .optionLine {
    border: 1px solid #d9d9d9;
    margin: 0 10px;
    height: 16px;
  }

  /* 옵션리스트 */
  .wrapContainer {
    padding: 0 45px;
  }
  .optionListWrap {
    flex: 1;
    overflow-y: auto;
  }

  /* tabContainer */
  .tabContainer {
    width: 100%;
    margin: 26px 0;
    display: flex;
    align-items: center;
    overflow-x: auto;
    -ms-overflow-style: none;
    scrollbar-width: none;

    h2 {
      padding: 6px 0 6px 0;
      font-size: 20px;
      font-weight: 500;
      color: #fff;
      white-space: nowrap;
      text-align: center;
    }
    .tab {
      width: 100%;
      border-bottom: 1px solid #4dd2ae;
      text-align: center;
      cursor: pointer;
    }
    .tab.active {
      border: 1px solid #4dd2ae;
      border-bottom: 2px solid #343434;
      border-top-right-radius: 4px;
      border-top-left-radius: 4px;

      h2 {
        color: #4dd2ae;
      }
    }
    .tabButton {
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        margin-left: 7px;
      }
    }
  }
  .tabContainer::-webkit-scrollbar {
    display: none;
  }

  /* 메뉴 */
  .setMenuWrap {
    .menuTitle {
      display: flex;
      margin-bottom: 6px;

      h1,
      h2,
      span {
        font-size: 16px;
        font-weight: 400;
        color: #e5e5e5;
      }
      h2,
      span {
        margin-left: 4px;
        color: #d14848;
      }
      span {
        color: #327ad0;
      }
    }
  }
  .setContainer {
    padding: 0 45px;
  }
  .setMenuInfoWrap {
    display: flex;
    flex-wrap: wrap;
    align-items: stretch;
    padding-bottom: 20px;
    gap: 1.2%;
    cursor: pointer;

    .setMenuInfo {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      width: 24%;
      margin-bottom: 10px;
      padding: 14px;
      border: 2px solid #fff;
      border-radius: 8px;
      background: #343434;

      h3,
      h4 {
        margin-bottom: 18px;
        font-size: 16px;
        font-weight: 600;
        word-break: break-all;
      }
      h4 {
        margin-bottom: 0;
      }
    }
    .setMenuInfo.sold {
      /* background: red; */
      position: relative;

      .soldText {
        width: 100%;
        height: 100%;
        background: #00000066;
        border-radius: 8px;
        position: absolute;
        top: 0;
        right: 0;
        display: flex;
        align-items: center;
        justify-content: center;

        h2 {
          font-size: 21px;
          font-weight: 600;
          color: #fff;
        }
      }
    }
    .setMenuInfo.selected {
      background: #40977f;
    }
  }

  /* 옵션 */
  .menuOptionWrap {
    width: 100%;

    .menuOptionTitle {
      display: flex;
      align-items: center;
      gap: 6px;

      h2,
      span {
        font-size: 16px;
        font-weight: 400;
      }
      span {
        color: #d14848;
      }
    }
  }
  .optionName {
    width: 100%;
    margin-bottom: 20px;
    border-top: 1px solid #555555;

    h3 {
      display: inline-block;
      padding: 6px 17px;
      background: #575757;
      color: #fff;
      font-size: 16px;
      font-weight: 400;
      border-bottom-right-radius: 5px;
      border-bottom-left-radius: 5px;
    }
  }
  .optionGroupWrap {
    display: flex;
    flex-wrap: wrap;
    margin: 6px 0 20px 0;
    gap: 0.8%;

    .optionGroup {
      width: 16%;
      margin-bottom: 8px;
      padding: 10px 12px;
      display: flex;
      align-items: stretch;
      justify-content: space-between;
      flex-direction: column;
      border: 2px solid #e5e5e5;
      border-radius: 10px;
      cursor: pointer;

      h2 {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        overflow: hidden;
        -webkit-line-clamp: 2;
        text-overflow: ellipsis;

        margin-bottom: 20px;
      }
      h2,
      p {
        font-size: 16px;
        font-weight: 400;
      }
    }
    .optionGroup.active {
      background: #296252;
    }
    .optionGroup.sold {
      background: #656565;
      border-color: #656565;
      h2,
      p {
        color: #979797;
      }
    }
  }

  /* footer */
  .modalFooter {
    position: fixed;
    width: 100%;
    bottom: 0;
    padding: 24px 45px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-top: 1px solid #555555;
    background-color: #343434;

    button {
      width: 50%;
      margin: 0 5px;
      padding: 14px 0;
      border-radius: 10px;
      background: #4dd2ae;
      border: 1px solid #4dd2ae;
      outline: none;

      h2 {
        color: #fff;
        font-weight: 600;
        font-size: 24px;
      }
    }
    .resetOptonButton {
      background: #343434;
      border: 1px solid #777777;
    }
  }
`;
